import { ABOUT_US } from "../Utilities/constants";

const About = () => {
  return (
    <div className=" py-32 text-[18px] tracking-wide font-[100] px-36">
      <h1>{ABOUT_US}</h1>
    </div>
  );
};

export default About;
